<template>
  <div
    id="WorkFindersComponent"
    class="mb-4"
  >
    <p>
      Please read our work
      finders agreement and
      sign your name in the
      box below if you agree
      to its terms
    </p>
    <p>You cannot continue until you have opened the document</p>
    <v-btn
      color="primary"
      text
      link
      outlined
      :href="'/agency-file/work-finders-agreement'"
      target="_blank"
      @click="$emit('wfa-clicked')"
    >
      <v-icon>
        mdi-file-document
      </v-icon>work finder's agreement
    </v-btn>
  </div>
</template>
<script>
export default {
  name: 'WorkFindersComponent',
  props: {
    tenant: {
      type: Object,
      default: () => {
        return {
          tenant: {
            settings: {
              work_finders_agreement: ''
            }
          }
        }
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    //
  }
}
</script>
<style lang='scss'>
    #WorkFindersComponent {
        //
    }
</style>
